module.exports = __webpack_public_path__ + "img/maintop.6ae2de1.png";